import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { AtlasUIProvider } from '@wellsky/atlas-ui-react'
import '@wellsky/atlas-ui-react/styles'
import './index.css'
import App from './App.tsx'
import { QueryProvider } from './providers/QueryProvider'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AtlasUIProvider defaultTheme="light" loadFonts={false}>
      <QueryProvider>
        <App />
      </QueryProvider>
    </AtlasUIProvider>
  </StrictMode>,
)
